import { NotifyHelper } from "../../../helpers/toast";
import { eDichVuThongTinActionsObj } from "../../action-types/dich-vu/IDichVuThongTinActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const dichVuThongTinActions = {
  ...generateActions(eDichVuThongTinActionsObj, "DICH_VU_THONG_TIN"),
  ...generateActionForKey(
    eDichVuThongTinActionsObj,
    "DICH_VU_THONG_TIN",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDichVuThongTinActionsObj,
    "DICH_VU_THONG_TIN",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDichVuThongTinActionsObj,
    "DICH_VU_THONG_TIN",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDichVuThongTinActionsObj,
    "DICH_VU_THONG_TIN",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
